
import Vue from 'vue'
import { authAxios } from '../utils'
import { Component } from 'vue-property-decorator'
import InvalidResetTokenCard from '../components/InvalidResetTokenCard.vue'
import PasswordResetSuccessCard from '../components/PasswordResetSuccessCard.vue'
import PasswordResetForm from '../components/PasswordResetForm.vue'
import PasswordResetTwoFactorCard from '../components/PasswordResetTwoFactorCard.vue'

interface ResetPasswordData {
  password: string;
  confirmPassword: string;
  token?: string;
  mfaToken?: string;
}

interface ResetTokenInfo {
  valid: boolean;
  reason?: string;
  twoFactorRequired: boolean;
}

@Component({
  components: { InvalidResetTokenCard, PasswordResetSuccessCard, PasswordResetForm, PasswordResetTwoFactorCard }
})
export default class ResetPasswordPage extends Vue {
  tokenValid = false

  invalidReason: string | null = null

  error: string | null = null

  step: 'password' | 'mfa' | 'success' = 'password'

  mfaRequired = false

  data: ResetPasswordData = {
    password: '',
    confirmPassword: ''
  }

  get paramToken() {
    return this.$route.params.token
  }

  async mounted() {
    try {
      const response = await authAxios.post<ResetTokenInfo>(`/reset-password/${this.paramToken}/validate`, { type: 'agency' })
      this.tokenValid = response.data.valid
      this.mfaRequired = response.data.twoFactorRequired
    } catch (error: any) {
      const data = error.response.data as ResetTokenInfo
      this.invalidReason = data.reason || null
      this.tokenValid = false
    }
  }

  submit(data: ResetPasswordData) {
    this.data = { ...data }
    if (this.mfaRequired) {
      this.step = 'mfa'
    } else {
      this.completeReset()
    }
  }

  async completeReset(code?: string) {
    const data = {
      ...this.data,
      token: this.paramToken,
      type: 'agency'
    }

    if (code) {
      data.mfaToken = code
    }

    try {
      await authAxios.post('/reset-password', data)
      this.step = 'success'
    } catch (error: any) {
      const responseCode = error.response.status
      if (responseCode >= 400 && responseCode < 500) {
        this.error = error.response.data.message
      } else {
        this.error = 'There was an error processing your request. Please try again in a few minutes.'
      }
    }
  }

  back() {
    this.step = 'password'
  }

  toLogin() {
    this.$router.push({ name: 'login' })
  }
}
